module.exports = __webpack_public_path__ + "img/new-ui-h5-clean.ab2403dc.png";